<script>
import _ from "lodash";
import Qs from "qs";
import Lockr from "lockr";
import BaseFilters from "../base-filters.vue";
import Api from "@/store/jsonapi";

export default {
  extends: BaseFilters,
  data: function () {
    return {
      group: "backend-invoices",
      built_in_filters: [
        {
          name: this.$i18n.t("all"),
          conditions: [],
          built_in: true,
        },

        {
          name: "All invoices",
          built_in: true,
          conditions: [
            {
              attr: "doc_type",
              value: {
                val: "invoice",
                label: this.$t("invoice"),
              },
            },
          ],
        },
        {
          name: "All credit memos",
          built_in: true,
          conditions: [
            {
              attr: "doc_type",
              value: {
                val: "credit_memo",
                label: this.$t("credit_memo"),
              },
            },
          ],
        },

        {
          name: "Paid invoices",
          built_in: true,
          conditions: [
            {
              attr: "payment_status",
              value: {
                val: "paid",
                label: this.$t("paid"),
              },
            },
            {
              attr: "doc_type",
              value: {
                val: "invoice",
                label: this.$t("invoice"),
              },
            },
          ],
        },
        {
          name: "Paid credit memos",
          built_in: true,
          conditions: [
            {
              attr: "payment_status",
              value: {
                val: "paid",
                label: this.$t("paid"),
              },
            },
            {
              attr: "doc_type",
              value: {
                val: "credit_memo",
                label: this.$t("credit_memo"),
              },
            },
          ],
        },

        {
          name: "Unpaid invoices",
          built_in: true,
          conditions: [
            {
              attr: "payment_status",
              value: {
                val: "unpaid",
                label: this.$t("unpaid"),
              },
            },
            {
              attr: "doc_type",
              value: {
                val: "invoice",
                label: this.$t("invoice"),
              },
            },
          ],
        },
        {
          name: "Unpaid credit memos",
          built_in: true,
          conditions: [
            {
              attr: "payment_status",
              value: {
                val: "unpaid",
                label: this.$t("unpaid"),
              },
            },
            {
              attr: "doc_type",
              value: {
                val: "credit_memo",
                label: this.$t("credit_memo"),
              },
            },
          ],
        },
        {
          name: "Unsynced invoices",
          built_in: true,
          conditions: [
            {
              attr: "ext_ref",
              value: {
                val: "",
                label: this.$t("ext_ref"),
              },
            },
          ],
        },
      ],
    };
  },
  computed: {
    attributes() {
      return [
        {
          name: "crediting_status",
          type: "Array",
          value: [
            {
              val: "not_credited",
              label: this.$t("not_credited"),
            },
            {
              val: "credited",
              label: this.$t("credited"),
            },
            {
              val: "partly_credited",
              label: this.$t("partly_credited"),
            },
          ],
        },
        {
          name: "doc_type",
          type: "Array",
          value: [
            {
              val: "invoice",
              label: this.$t("paid"),
            },
            {
              val: "credit_memo",
              label: this.$t("credit_memo"),
            },
          ],
        },
        {
          name: "payment_status",
          type: "Array",
          value: [
            {
              val: "paid",
              label: this.$t("paid"),
            },
            {
              val: "unpaid",
              label: this.$t("unpaid"),
            },
          ],
        },
      ];
    },
  },
  methods: {
    // after_mount() {
    // }
  },
};
</script>
